"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconobot = _interopRequireDefault(require("../../../../images/iconobot.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageDialog = function MessageDialog(_ref) {
  var message = _ref.message,
      initials = _ref.initials;

  var MessageBody = function MessageBody() {
    return message.sender === 'user' ? /*#__PURE__*/_react.default.createElement("div", {
      className: "Chatbot__Messenger__ChatLog-message-body-".concat(message.sender, " ")
    }, /*#__PURE__*/_react.default.createElement("p", null, message.message)) : /*#__PURE__*/_react.default.createElement("div", {
      className: "Chatbot__Messenger__ChatLog-message-body-".concat(message.sender, " "),
      dangerouslySetInnerHTML: {
        __html: message.message
      }
    });
  };

  var MessageUser = function MessageUser() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "Chatbot__Messenger__ChatLog-message-logo-".concat(message.sender)
    }, message.sender === 'user' ? /*#__PURE__*/_react.default.createElement("span", {
      className: "Chatbot__Messenger__ChatLog-message-user-initials"
    }, initials) : /*#__PURE__*/_react.default.createElement("div", {
      className: "Chatbot__Messenger__ChatLog-message-user-bot"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _iconobot.default,
      alt: "bot"
    })));
  };

  var MessageBuilt = function MessageBuilt() {
    return message.sender === 'user' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MessageBody, null), /*#__PURE__*/_react.default.createElement(MessageUser, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MessageUser, null), /*#__PURE__*/_react.default.createElement(MessageBody, null));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Chatbot__Messenger__ChatLog-message Chatbot__Message__Theme-".concat(message.sender, " shadow")
  }, /*#__PURE__*/_react.default.createElement(MessageBuilt, null));
};

;

var Message = /*#__PURE__*/_react.default.memo(function (_ref2) {
  var message = _ref2.message,
      initials = _ref2.initials;
  return /*#__PURE__*/_react.default.createElement(MessageDialog, {
    message: message,
    initials: initials
  });
});

Message.propTypes = {
  message: _propTypes.default.shape({
    id: _propTypes.default.string,
    sender: _propTypes.default.oneOf(['user', 'chatbot']),
    message: _propTypes.default.string
  }).isRequired
};
var _default = Message;
exports.default = _default;